import { CloseOutlined } from '@ant-design/icons';
import { Box, Grid, Stack, Typography } from '@mui/material';
import Avatar from 'components/@extended/Avatar';
import IconButton from 'components/@extended/IconButton';

type SelectedItemCardProps = {
    title: string;
    subTitle?: string;
    image?: string | JSX.Element;
    onRemove: () => void;
};

const SelectedItemCard = ({ title, subTitle, image, onRemove }: SelectedItemCardProps) => {
    return (
        <Box
            borderRadius={2}
            height={72}
            sx={{ border: '1px solid', borderColor: (theme) => theme.palette.grey.A800 }}
            padding={1.5}
        >
            <Grid container alignItems="center">
                {image && (
                    <Grid item xs={2}>
                        {typeof image === 'string' ? <Avatar sizes="md" src={image} /> : <Avatar>{image}</Avatar>}
                    </Grid>
                )}
                <Grid item xs={9}>
                    <Stack spacing={0.5} justifyContent="center">
                        <Typography variant="caption" color={(theme) => theme.palette.grey[500]}>
                            {subTitle}
                        </Typography>
                        <Typography variant="h6">{title}</Typography>
                    </Stack>
                </Grid>
                <Grid item xs={1} justifySelf="self-end">
                    <IconButton
                        aria-label="close"
                        onClick={onRemove}
                        sx={{
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseOutlined />
                    </IconButton>
                </Grid>
            </Grid>
        </Box>
    );
};

export default SelectedItemCard;
